var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultOrganizationSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.62,
    height: 56.614,
    viewBox: "0 0 61.62 56.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_7473",
    "data-name": "\\u7EC4 7473",
    transform: "translate(340 263.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_7471",
    "data-name": "\\u7EC4 7471",
    transform: "translate(-340 -263.228)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_9254",
    "data-name": "\\u8DEF\\u5F84 9254",
    d: "M-280.305-210.466h-3.852v-34.661c0-5.392-3.081-7.7-5.007-8.088l-12.324-3.851V-261.3a2,2,0,0,0-.77-1.541,2.316,2.316,0,0,0-1.541-.385l-25.8,7.317s-4.621,1.155-4.621,7.317v38.128h-3.851A1.819,1.819,0,0,0-340-208.54a1.819,1.819,0,0,0,1.926,1.926h57.769a1.819,1.819,0,0,0,1.925-1.926,1.819,1.819,0,0,0-1.925-1.925Zm-25.033,0h-25.033v-38.128c0-2.7,1.54-3.466,1.926-3.466l23.108-6.547Zm17.331,0h-13.479v-42.749l11.169,3.851h.385c.385,0,1.925.385,1.925,4.236Zm-31.58-38.9h-3.851v3.851h3.851Zm8.858,0h-3.851v3.851h3.851Zm-8.858,6.162h-3.851v3.851h3.851Zm8.858,0h-3.851v3.851h3.851Zm-8.858,6.547h-3.851v3.851h3.851Zm8.858,0h-3.851v3.851h3.851Zm-8.858,6.547h-3.851v3.851h3.851Zm8.858,0h-3.851v3.851h3.851Zm-8.858,6.162h-3.851v3.852h3.851Zm8.858,0h-3.851v3.852h3.851Zm-8.858,6.547h-3.851v3.851h3.851Zm8.858,0h-3.851v3.851h3.851Zm14.25-21.952h3.851V-243.2h-3.851Zm0,6.547h3.851v-3.851h-3.851Zm0,6.547h3.851v-3.851h-3.851Zm0,6.162h3.851v-3.852h-3.851Zm0,6.547h3.851V-217.4h-3.851Zm0,0",
    transform: "translate(340 263.228)",
    fill: "#c8ced7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultOrganizationSquare);
export default __webpack_public_path__ + "static/media/DefaultOrganizationSquare.ac6ac7c3d137dc157ab16ae9d880958e.svg";
export { ForwardRef as ReactComponent };